import React, { useEffect, useState } from 'react';
import './WinnerScreen.css';

/**
 * Winner celebration screen with confetti
 */
const WinnerScreen = ({ winner, isCurrentPlayer, onPlayAgain, onLeave }) => {
  const [confetti, setConfetti] = useState([]);

  useEffect(() => {
    // Generate confetti pieces
    const pieces = Array.from({ length: 50 }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      delay: Math.random() * 2,
      color: ['#e94560', '#ffd700', '#00d26a', '#4169e1', '#ff69b4'][Math.floor(Math.random() * 5)]
    }));
    setConfetti(pieces);
  }, []);

  return (
    <div className="winner-screen">
      {/* Confetti */}
      <div className="confetti-container">
        {confetti.map(piece => (
          <div
            key={piece.id}
            className="confetti-piece"
            style={{
              left: `${piece.left}%`,
              animationDelay: `${piece.delay}s`,
              backgroundColor: piece.color
            }}
          />
        ))}
      </div>

      <div className="winner-content fade-in">
        <div className="trophy">🏆</div>
        <h1 className="winner-title">
          {isCurrentPlayer ? 'YOU WON!' : 'GAME OVER!'}
        </h1>
        <div className="winner-name">
          <span className="crown">👑</span>
          {winner.name}
          <span className="crown">👑</span>
        </div>
        <p className="winner-message">
          {isCurrentPlayer 
            ? 'Congratulations! You cleared all your cards first!' 
            : `${winner.name} cleared all their cards first!`}
        </p>
        
        <div className="winner-actions">
          <button className="btn btn-primary" onClick={onPlayAgain}>
            🔄 Play Again
          </button>
          <button className="btn btn-secondary" onClick={onLeave}>
            🚪 Leave Game
          </button>
        </div>
      </div>
    </div>
  );
};

export default WinnerScreen;


